import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class VimeoService {
  constructor() {}

  getVimeoEmbed(videoUrl: string): Observable<{ data: { getVimeoEmbed: { html: string } } }> {
    const result: Observable<{ data: { getVimeoEmbed: { html: string } } }> = new Observable((observer) => {
      const url = new URL('https://vimeo.com/api/oembed.json');
      const windowWidth = window.innerWidth - 48;
      const windowHeight = window.innerHeight - 48;
      const params = { url: encodeURI(videoUrl), maxwidth: `${(windowWidth > 1104 ? 1104 : windowWidth)}`, maxheight: `${windowHeight}` };
      url.search = new URLSearchParams(params).toString();

      fetch(url.href).then((response) => {
        response.json().then((data) => {
          observer.next({
            data: {
              getVimeoEmbed: {
                html: data.html,
              },
            },
          });
        }).catch((error) => observer.error(error));
      });
    });

    return result;
  }
}
